import { principles } from '../content/principles';

/** Founding principles — numbered because the four ARE an enumerated, ordered set of commitments. */
export default function Principles() {
  return (
    <article className="mx-auto w-full max-w-prose px-6 py-16 sm:py-20">
      <p className="font-display text-xs font-semibold uppercase tracking-[0.28em] text-accent-deep">
        {principles.eyebrow}
      </p>
      <h1 className="mt-3 font-display text-3xl font-semibold uppercase tracking-[0.12em] text-ink sm:text-4xl">
        {principles.title}
      </h1>
      <p className="mt-4 font-serif text-xl italic text-muted">{principles.lede}</p>
      <hr className="my-10 border-border" />

      <ol className="space-y-10">
        {principles.items.map((item, i) => (
          <li key={item.heading} className="grid grid-cols-[auto_1fr] gap-x-5">
            <span
              aria-hidden
              className="font-display text-2xl font-semibold tabular-nums text-accent"
            >
              {String(i + 1).padStart(2, '0')}
            </span>
            <div>
              <h2 className="font-display text-lg font-semibold uppercase tracking-[0.12em] text-ink">
                {item.heading}
              </h2>
              {item.paragraphs.map((p, j) => (
                <p key={j} className="mt-3 font-serif text-lg leading-relaxed text-ink">
                  {p}
                </p>
              ))}
            </div>
          </li>
        ))}
      </ol>

      <p className="mt-12 border-t border-border pt-6 font-serif text-lg italic text-accent-deep">
        {principles.motto}
      </p>
    </article>
  );
}
